import * as React from 'react';
import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';
import MDBox from "../MDBox";

const SkeletonCard = () => {
    return (
        <MDBox sx={{ width: '100%', margin: '0 auto' }}>

                    <MDBox sx={{ marginTop: 2 }}>
                        <Skeleton variant="rectangular" width="100%"  height={'10vh'} />
                        <MDBox sx={{ marginTop: 1 ,display:'flex',justifyContent:'space-between'}}>
                            <Skeleton width="33%" />
                            <Skeleton width="33%" />
                            <Skeleton width="33%" />
                        </MDBox>
                        <MDBox sx={{ marginTop: 1 ,display:'flex',justifyContent:'space-between'}}>
                            <Skeleton width="33%" />
                            <Skeleton width="33%" />
                            <Skeleton width="33%" />
                        </MDBox>

                        <Skeleton variant="rectangular" width="100%"  height={'80vh'} sx={{marginTop:1,maxHeight:'500px'}}/>
                        <Skeleton variant="rectangular" width="100%"  height={'10vh'} sx={{marginTop:1,maxHeight:'500px'}}/>
                    </MDBox>

        </MDBox>
    );
};

export default SkeletonCard;